enum OpenDesignCodeLengthEnum {
	min = 5,
	max = 6
}
export default OpenDesignCodeLengthEnum;
